import { RecordPlayTimeRequestModel } from './record-play-time.request.model';

export class RecordPlayTimeRequestMessage {
  RecordPlayTimeRequestMessage!: RecordPlayTimeRequestModel;
}
